<template>
  <card>
    <template v-slot>
      <div class="flex item-start">
        <div class="flex-shrink-0"><v-shield-check-outline></v-shield-check-outline></div>
        <div class="flex-1">
          <div class="text-2xl font-semibold leading-6 flex-1 mx-2">
            Inloggen in twee stappen (2FA) uitschakelen
          </div>
        </div>
      </div>
      <div class="grid my-2">
        <div class="w-1/3">
          <p>Er is een code verstuurd naar uw email. Vul deze hieronder in om het uit te schakelen.</p>
          <v-input-group-simple-2
            id="deauthorizationCode"
            v-model:value="deauthorizationCode"
            maxlength="6"
            placeholder="Uw verificatiecode"
            data-vv-as="Uw verificatiecode"
            :overwrite-value="deauthorizationCode"
            :rules="{
              required: false
            }"
            @input="saveInput($event)"
          />
          <small v-if="authenticationNotDisabled && !showResendText" class="text-red-700 block mx-2 my-4">
           De ingevoerde 2FA code is ongeldig
          </small>
          <small v-if="showResendText && !authenticationNotDisabled" class="text-red-700 block mx-2 my-4">
            Er is een nieuwe code verstuurd naar uw email.
          </small>
          <v-button class="resend-button ml-1 py-2.5" transparent hollow @click="resendVerificationCode()">
           Code opnieuw versturen
          </v-button>
        </div>
      </div>
      <div class="row justify-end">
        <v-button md hollow transparent @click="closeEditAuthentication"> Annuleren </v-button>
        <v-button :disabled="deauthorizationCode.length <= 5" md primary @click="disable2FA()"> Bevestigen </v-button>
      </div>
    </template>
  </card>
</template>

<script>
import { tap } from 'rxjs/operators';
import VShieldCheckOutline from 'icons/ShieldCheckOutline';
import {
  currentUserIdentity$,
  disable2FactorAuthentication,
  twoFactorAuthenticationNotDisabledEvent$,
  twoFactorAuthenticationDisabledEvent$
} from '@/services';
import { ref, onMounted } from 'vue';

export default {
  name: 'PrescriberTwoFactorDisableAuthModal',
  components: { VShieldCheckOutline },
  setup() {
    const currentUserIdentity = ref(null);
    const twoFactorAuthenticationDisabledEvent = ref(null);
    const twoFactorAuthenticationNotDisabledEvent = ref(null);
    const deauthorizationCode = ref('');
    const authenticationNotDisabled = ref(null);
    const showResendText = ref(null);

    currentUserIdentity$.subscribe((value) => (currentUserIdentity.value = value));
    twoFactorAuthenticationDisabledEvent$.subscribe((value) => (twoFactorAuthenticationDisabledEvent.value = value));

    twoFactorAuthenticationNotDisabledEvent$.pipe(
      tap((e) => {
        this.deauthorizationCode = '';
        this.authenticationNotDisabled = true;
        this.showResendText = false;
      })
    );

    const saveInput = (event) => {
      deauthorizationCode.value = event.target.value;
    };

    onMounted(() => disable2FactorAuthentication());

    return {
      currentUserIdentity,
      twoFactorAuthenticationDisabledEvent,
      twoFactorAuthenticationNotDisabledEvent,
      deauthorizationCode,
      authenticationNotDisabled,
      showResendText,
      saveInput
    };
  },
  methods: {
    closeEditAuthentication() {
      this.$emit('closeEditAuthentication', false);
    },
    resendVerificationCode() {
      disable2FactorAuthentication();
      this.showResendText = true;
      this.authenticationNotDisabled = false;
    },
    async disable2FA() {
      await disable2FactorAuthentication(this.deauthorizationCode).then((response) => {
        if (response?.data?.length > 1) {
          this.closeEditAuthentication();
          this.$emit('success');
        } else {
          this.$emit('error');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.resend-button {
  color: $black;
  text-decoration: underline;
  font-weight: 400;
}
</style>
